import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';

import { getSortingKeys } from '../../utils/sorting';
import { changeSorting } from '../../store/filters/actions';
import { Sorting } from '../../components/sorting/index';
import { SortingMobile } from '../../components/mobile/SortingMobile';

export const mapStateToProps = (state: IApplicationState) => {
  const defaultSorting = getSortingKeys().DEFAULT;
  const {
    filters: { regionId, sorting = defaultSorting },
    roads: { regionHasRoads },
    stations: { regionHasStations },
  } = state;

  return {
    regionHasRoads,
    regionHasStations,
    regionId,
    sorting,
    totalItems: Number(state.villageList && state.villageList.totalItems),
  };
};

export const mapDispatchToProps = (dispatch: TTypedThunkDispatch) => ({
  onSelect: (type: string) => {
    dispatch(changeSorting(type));
  },
});

export const SortingContainer = connect(mapStateToProps, mapDispatchToProps)(Sorting);

export const SortingContainerMobile = connect(mapStateToProps, mapDispatchToProps)(SortingMobile);
